export default __webpack_public_path__ + "static/media/agenda_aeropuerto.b35764a4.png";